import { initializeApp } from "firebase/app";
import { getAuth} from "firebase/auth";
import {getStorage, ref, uploadBytes, getDownloadURL} from "firebase/storage"

const firebaseConfig = {
  apiKey: "AIzaSyAYdF4Qn4ZiR5Zw5TEIOGaay9mxUxES_Y0",
  authDomain: "ecommerce-nemotec.firebaseapp.com",
  projectId: "ecommerce-nemotec",
  storageBucket: "ecommerce-nemotec.appspot.com",
  messagingSenderId: "269235174576",
  appId: "1:269235174576:web:a7a93ffc9c64f30c7c0f75",
  measurementId: "G-3CV1T2XXW2"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app)
export const storage = getStorage(app)
/**
 * upload a file to firebase storage
 * @param {File} file 
 * @param {String} name 
 * @returns {Promise<String>}url of the image
 */
export async function uploadFile(file, name){
  const storageRef = ref(storage, name)
  await uploadBytes(storageRef, file)
  const url = await getDownloadURL(storageRef)
  return url
}